(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiAskExam', taiAskExam);

    function taiAskExam() {
        var directive = {
            bindToController: true,
            controllerAs: 'vm',
            controller: ControllerController,
            link: link,
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/modal/taiAskExam.html',
            scope: {
                showView: '=',
                sessionId: '=',
                courseActiveItem: '=',
            },
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController($rootScope, $scope, trainingInnerService, modalService, $q, $interval) {
        var vm = this;
        vm.submitExam = submitExam;
        vm.retryTest = retryTest;
        vm.reviewContent = reviewContent;
        vm.reviewResult = reviewResult;
        vm.countingTimeShowing = countingTimeShowing;
        init();
        //================
        function init() {
            $q.when(dataInit()).then(function() {

            });
            $scope.$watch('vm.showView', function(newValue) {
                // if (newValue === oldValue) { return; }
                if (vm.courseActiveItem && newValue) {
                    elementLoad();
                } else {
                    if (vm.countingSecsInterval) {
                        $interval.cancel(vm.countingSecsInterval);
                    }
                }
            });
        }

        function dataInit() {
            //該頁會使用變數都在這裡
            vm.view = {
                show: false, //............這個元件是否應該顯示
                content: false, //..........試題頁
                examInfo: false, //.........測驗額外資訊
                result: false, //...........測驗回傳結果
                resultTest: false, //.......回傳結果顯示頁面(測試)
                resultQuest: false, //......回傳結果顯示頁面(問卷)
                dataLoadSucess: false, //...畫面讀取成功
                dataLoadFail: false, //.....畫面讀取失敗
                hasSubmit: false, //........是否送出過
                canRetry: false, //.........是否能重新受測
            };
            vm.importData = {
                //為避免雙向綁定造成的一些狀況，要將來源資料保存
                courseActiveItem: null,
                sessionId: null,
            };
            vm.data = {
                countingSecs: 0,
                examContent: null,
                examContentGroup: null,
                examContentRefer: null,
                result: null
            };
            vm.courseActiveItem = vm.courseActiveItem || null;
            vm.sessionId = vm.sessionId || null;
            vm.showView = vm.showView || false;
            if (vm.countingSecsInterval) {
                $interval.cancel(vm.countingSecsInterval);
            }
        }

        function elementLoad() {
            $q.when(dataInit()).then(function() {
                if (!vm.courseActiveItem || !vm.sessionId) {
                    return;
                }
                if (vm.courseActiveItem.type !== "測驗" && vm.courseActiveItem.type !== "問卷") {
                    return;
                }
                vm.view.show = true;
                vm.importData.courseActiveItem = angular.copy(vm.courseActiveItem);
                vm.importData.sessionId = angular.copy(vm.sessionId);
                //=====
                var examItemOrder;
                trainingInnerService.getExamSurveyContent(vm.importData.sessionId, vm.importData.courseActiveItem)
                    .then(function(data) {
                        if (!data) {
                            vm.view.dataLoadFail = true;
                            return;
                        }
                        vm.data.examContent = data;
                        vm.data.examContent.limitTimesText = limitTimesFormat(vm.data.examContent.limitTimes);
                        if (vm.data.examContent.remainingTimes > vm.data.examContent.limitTimes) {
                            vm.data.examContent.remainingTimes = vm.data.examContent.limitTimes;
                        }
                        if (vm.courseActiveItem.type === "測驗") {
                            vm.view.examInfo = true;
                        }
                        if (vm.data.examContent.remainingMins > 0) {
                            vm.countingSecsInterval = $interval(function() {
                                if (vm.data.countingSecs < 1) {
                                    vm.data.countingSecs = 0;
                                    submitExam(true, true);
                                } else {
                                    vm.data.countingSecs--;
                                }
                            }, 1000);
                        }
                        vm.data.countingSecs = remainingMinsFormat(vm.data.examContent.remainingMins);
                        vm.view.content = true;
                        vm.view.canRetry = (vm.data.examContent.remainingTimes < 0 || vm.data.examContent.remainingTimes > 1);
                        vm.data.examContentRefer = {}; // 作為類似DIctionary的索引
                        vm.data.examContentGroup = _.chain(vm.data.examContent.questions)
                            .groupBy("groupName")
                            .map(function(examList) {
                                examItemOrder = 1;
                                _.forEach(examList, function(examItem) {
                                    //===索引製作===
                                    if (!vm.data.examContentRefer[examItem.questionId]) {
                                        vm.data.examContentRefer[examItem.questionId] = [];
                                    }
                                    vm.data.examContentRefer[examItem.questionId].push(examItem);
                                    //=============
                                    //===自訂屬性===
                                    examItem.order = examItemOrder++;
                                    examItem.value = null;
                                    examItem.typeText = '';
                                    examItem.isCorrect = null;
                                    examItem.showOrder = false;
                                    examItem.choiceStyle = {
                                        Line: false,
                                        Layer: false
                                    };
                                    _.forEach(examItem.options, function(optionItem) {
                                        optionItem.textValue = ''; //..........專門給選擇題帶問答區塊使用(像是其他)
                                        optionItem.preTitle = false; //........標題是否要前置
                                        optionItem.correctAnswer = null; //....代表為正確答案
                                    });
                                    //=============
                                    switch (examItem.questionType) {
                                        case 2:
                                            //複選
                                            examItem.choiceStyle.Layer = true;
                                            examItem.typeText = $rootScope.translate.tsunTestTypeMulti;
                                            if (!examItem.options) {
                                                break;
                                            }
                                            examItem.value = [null]; //預設位置0為NULL(因為照ORDER處理)
                                            // _.forEach(examItem.options, function (optionItem) {
                                            //     if (optionItem.value) {
                                            //         examItem.value[optionItem.order] = true;
                                            //     }
                                            //     else {
                                            //         examItem.value[optionItem.order] = false;
                                            //     }
                                            // });
                                            break;
                                        case 3:
                                            //問答
                                            examItem.choiceStyle.Layer = true;
                                            examItem.typeText = $rootScope.translate.tsunTestTypeEssay;
                                            examItem.value = "";
                                            // if (examItem.options.length > 0) {
                                            //     examItem.value = examItem.options[0].value;
                                            // }
                                            break;
                                        case 7:
                                            //填充
                                            examItem.choiceStyle.Layer = true;
                                            examItem.typeText = $rootScope.translate.tsunTestTypeBlankFill;
                                            examItem.value = "";
                                            // if (examItem.options.length > 0) {
                                            //     examItem.value = examItem.options[0].value;
                                            // }
                                            break;
                                        case 1:
                                        case 6:
                                            //單選
                                            //是非題
                                            examItem.choiceStyle.Layer = true;
                                            examItem.typeText = $rootScope.translate.tsunTestTypeSingle;
                                            examItem.value = 0;
                                            // _.forEach(examItem.options, function (optionItem) {
                                            //     if (examItem.value < 1 && optionItem.value && optionItem.order > 0) {
                                            //         examItem.value = optionItem.order;
                                            //     }
                                            // });
                                            break;
                                        case 4:
                                        case 5:
                                            examItem.showOrder = true;
                                            examItem.options[0].preTitle = true;
                                            examItem.choiceStyle.Line = true;
                                            examItem.typeText = '';
                                            examItem.value = 0;
                                            // _.forEach(examItem.options, function (optionItem) {
                                            //     if (examItem.value < 1 && optionItem.value && optionItem.order > 0) {
                                            //         examItem.value = optionItem.order;
                                            //     }
                                            // });
                                            break;
                                        default:
                                            //其餘
                                            examItem.choiceStyle.Line = true;
                                            examItem.typeText = '';
                                            examItem.value = 0;
                                            // _.forEach(examItem.options, function (optionItem) {
                                            //     if (examItem.value < 1 && optionItem.value && optionItem.order > 0) {
                                            //         examItem.value = optionItem.order;
                                            //     }
                                            // });
                                            break;
                                    }
                                });
                                return {
                                    'key': examList[0].groupName,
                                    'value': examList
                                };
                            }).value();
                        vm.view.dataLoadSucess = true;
                         
                        // 解決表單有時在IE無法輸入問題
                        fixIeNotAbleToInput('.modal');

                    });
            });
        }

        function countingTimeShowing(timeSpan) {
            if (timeSpan !== parseInt(timeSpan, 10)) {
                //如果有特別顯示字樣就不處理了。
                return timeSpan;
            }
            var sec_num;
            try {
                sec_num = parseInt(timeSpan, 10); // don't forget the second param
            } catch (exp) {
                sec_num = 0;
            }
            var minutes = Math.floor((sec_num / 60));
            var seconds = sec_num - (minutes * 60);
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            return minutes + ':' + seconds;
        }

        function submitExam(finish, forceSubmit) {
            if (!finish) { return; }
            if (vm.countingSecsInterval) {
                $interval.cancel(vm.countingSecsInterval);
            }
            var itemType;
            var questRequiredUnAnswer = '';
            var questRequiredUnAnswerPerGroup = {};
            var questUnAnswer = '';
            var questUnAnswerPerGroup = {};
            var strEmptyGroupName = '';
            var otherAns = '';// 其他答案的自填答案
            itemType = vm.importData.courseActiveItem ? vm.importData.courseActiveItem.type : '';
            vm.data.examContent.finish = finish ? 1 : 0;
            vm.data.examContent.answers = [];
            _.forEach(vm.data.examContent.questions, function(examItem) {

                if (!examItem.groupName || examItem.groupName.lenght < 1) {
                    examItem.groupName = strEmptyGroupName;
                }
                var perAnswer = '';
                var examItemAnswer = '';
                if (angular.isArray(examItem.value)) {
                    _.forEach(examItem.value, function(value, valueIndex) {
                        //console.log('examItem:', examItem);
                        if (value && valueIndex > 0) {
                            if (examItemAnswer) { examItemAnswer += ','; }
                            examItemAnswer += valueIndex;
                        }
                    });
                    //加上其他答案(複選)
                    if (examItem.options[examItem.options.length - 1].textValue) {
                        otherAns = examItem.options[examItem.options.length - 1].textValue;
                        examItemAnswer += ',clOtherAnswer=' + otherAns;
                    }
                    if (!examItemAnswer) { examItemAnswer = 0; }
                    //console.log('examItemAnswer:', examItemAnswer);
                } else {
                    examItemAnswer = angular.copy(examItem.value);
                    //加上其他答案 (單選)
                    if (examItem.options[examItem.options.length - 1].textValue) {
                        otherAns = examItem.options[examItem.options.length - 1].textValue;
                        examItemAnswer += ',clOtherAnswer=' + otherAns;
                    }
                    //console.log('examItem22:', examItemAnswer);
                }
                //console.log("exam order:", examItem.order, ".....examItemAnswer:", examItemAnswer);
                if (!examItemAnswer || examItemAnswer.length < 1) {
                    examItemAnswer = '0';
                    if (examItem.questionType === 3 || examItem.questionType === 7) {
                        examItemAnswer = '\0';
                    }
                    if (examItem.required) {
                        if (!questRequiredUnAnswerPerGroup[examItem.groupName]) {
                            questRequiredUnAnswerPerGroup[examItem.groupName] = '';
                        }
                        if (questRequiredUnAnswerPerGroup[examItem.groupName].length > 0) {
                            questRequiredUnAnswerPerGroup[examItem.groupName] += ',';
                        }
                        questRequiredUnAnswerPerGroup[examItem.groupName] += examItem.order;
                    } else {
                        if (!questUnAnswerPerGroup[examItem.groupName]) {
                            questUnAnswerPerGroup[examItem.groupName] = '';
                        }
                        if (questUnAnswerPerGroup[examItem.groupName].length > 0) {
                            questUnAnswerPerGroup[examItem.groupName] += ',';
                        }
                        questUnAnswerPerGroup[examItem.groupName] += examItem.order;
                    }
                }
                if (examItemAnswer) {
                    perAnswer = examItemAnswer;
                    perAnswer = examItem.questionId + "_" + perAnswer;
                }
                if (perAnswer) {
                    vm.data.examContent.answers.push(perAnswer);
                }

            });
            //======必填欄位驗證
            _.forEach(questRequiredUnAnswerPerGroup, function(value, key) {
                if (key.lenght > 0) {
                    questRequiredUnAnswer += key + ':';
                }
                questRequiredUnAnswer += value + '\n';
            });
            if (questRequiredUnAnswer.length > 0 && vm.data.examContent.finish === 1 && !forceSubmit) {
                toastr.warning($rootScope.translate.tsunTest + '\n' + questRequiredUnAnswer + $rootScope.translate.tsunTestRequiredAlert);
                return;
            }
            //=====未填欄位確認
            _.forEach(questUnAnswerPerGroup, function(value, key) {
                if (key.lenght > 0) {
                    questUnAnswer += key + ':';
                }
                questUnAnswer += value + '\n';
            });

            vm.data.examContent.activeItemtype = itemType; //TODO 這邊加入是為了測試環境的簡單互動，若要移除測試環境時可以將此行拿掉。
            if (questUnAnswer.length > 0 && vm.data.examContent.finish === 1 && !forceSubmit) {

                var confirmDialog = modalService.confrimDialog({
                    confirmContent: ($rootScope.translate.tsunTest + '\n' + questUnAnswer + $rootScope.translate.tsunTestComfirm),
                });
                confirmDialog.result.then(function(result) {
                    result = !!result;
                    if (result !== true) {
                        return;
                    }
                    return postExamSurveyContent(finish, itemType);
                });
            } else {
                return postExamSurveyContent(finish, itemType);
            }
        }

        function postExamSurveyContent(finish, itemType) {
            console.log("examContent :", vm.data.examContent);
            var resultPost = trainingInnerService.postExamSurveyContent(vm.importData.sessionId, vm.data.examContent);
            return resultPost.then(function(result) {
                console.log("postExamSurveyContent result:", result);
                if (!result) { return; }
                vm.data.result = result;
                viewShowContentFormat();
                vm.view.hasSubmit = true;
                vm.view.examInfo = false;

                // 問卷後續會 emit 報名課程作業，因此由那邊顯示成功或失敗訊息即可
                if (finish && itemType === '測驗') {
                    console.log('yo-postExamSurveyContent:', result);
                    //應台新要求將發送成功的訊息拿掉
                    //toastr.success($rootScope.translate.tsunSendSuccess); 
                }

                if (itemType === '測驗') {
                    vm.view.resultTest = true;
                }
                if (itemType === '問卷') {
                    vm.view.resultQuest = true;
                }
                if (itemType === '測驗' && vm.data.examContent.finish === 1) {
                    vm.view.result = true;
                    //測驗結果顯示
                    _.forEach(vm.data.result.questionResults, function(resultItem) {
                        var referData;
                        //===資料檢核===
                        if (!vm.data.examContentRefer[resultItem.questionId]) { return; }
                        if (!angular.isArray(vm.data.examContentRefer[resultItem.questionId])) { return; }
                        //=============
                        referData = vm.data.examContentRefer[resultItem.questionId];
                        _.forEach(referData, function(examItem) {
                            var resultCorrectAnswerForMulti = resultItem.correctAnswer.split(',');
                            examItem.isCorrect = (resultItem.correctAnswer === resultItem.studentAnswer);
                            examItem.value = null;
                            //=====處理學生填答=====
                            if (examItem.questionType === 3 || examItem.questionType === 7) {
                                examItem.value = resultItem.studentAnswer;
                            } else if (examItem.questionType === 2) {
                                var resultStudentAnswer = resultItem.studentAnswer.split(',');
                                examItem.value = [];
                                _.forEach(resultStudentAnswer, function(answerItem) {
                                    examItem.value[answerItem] = true;
                                });
                            } else {
                                examItem.value = resultItem.studentAnswer;
                            }
                            //===================
                            //=====正確答案處理=====
                            //若resultItem.correctAnswer為空應該就是沒有正確答案 = 不用處理
                            if (resultItem.correctAnswer.length < 1) { return; }
                            _.forEach(examItem.options, function(optionItem) {
                                var optionOrder = optionItem.order + '';

                                if (examItem.questionType === 3 || examItem.questionType === 7) {
                                    // 移除此行避免用戶輸入的資料變成正確資料
                                    // examItem.value = resultItem.correctAnswer;
                                    optionItem.correctAnswer = resultItem.correctAnswer;
                                    //console.log('examItem:', examItem);
                                } else if (examItem.questionType === 2) {
                                    _.forEach(resultCorrectAnswerForMulti, function(answerItem) {
                                        //console.log('answerItem:',answerItem);
                                        //optionItem.correctAnswer = false; //
                                        if (optionOrder === answerItem) {
                                            optionItem.correctAnswer = true;
                                        }
                                    });
                                } else {
                                    optionItem.correctAnswer = (optionOrder === resultItem.correctAnswer);
                                }
                            });

                            //=====================
                        });
                    });
                }

                // 觸發 emitExamSubmit 執行報名作業
                // courseDetailModalController enroll
                $scope.$emit('emitExamSubmit', '');

            });
        }

        function viewShowContentFormat() {
            vm.view.resultTest = false;
            vm.view.resultQuest = false;
            vm.view.content = false;
        }

        function retryTest() {
            elementLoad();
            $scope.$emit('goTop', '');
        }

        function reviewContent() {
            viewShowContentFormat();
            vm.view.content = true;
        }

        function reviewResult() {
            viewShowContentFormat();
            vm.view.resultTest = true;
        }

        function limitTimesFormat(times) {
            var result = times;
            if (parseInt(times) < 0) {
                result = $rootScope.translate.tsunNoLimit;
            }
            return result;
        }

        function remainingMinsFormat(remainMins) {
            var result = '';
            if (remainMins > -1) {
                result = remainMins;
            } else {
                result = $rootScope.translate.tsunNoLimit;
            }
            return result;
        }
    }
})();